import { render, staticRenderFns } from "./link_change.vue?vue&type=template&id=34c709ad&scoped=true&"
import script from "./link_change.vue?vue&type=script&lang=js&"
export * from "./link_change.vue?vue&type=script&lang=js&"
import style0 from "./link_change.vue?vue&type=style&index=0&id=34c709ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c709ad",
  null
  
)

export default component.exports